
export interface CartLine {
  id: string;
  product_id: string;
  product_variant_id?: string;
  product_type: number;
}
